import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import InvoiceDraftDetail from '../../invoices/components/InvoiceDraftDetail';

interface Props {
  supplierOrderId: string;
  /** `'new'` starts a new purchase invoice of this ZD, an id opens that draft; null = closed. */
  invoiceId: string | null;
  transportId?: string;
  receiptOnly?: boolean;
  transportLabel?: string;
  truckOpenQuantities?: Record<string, number>;
  onClose: () => void;
  onPersisted: () => void;
}

/**
 * The purchase invoice editor over the ZD card. One home for the dialog: the
 * „Finanse” tab list and the stage panel (task „Faktura zakupu”) both open it.
 */
export default function SupplierOrderPurchaseInvoiceModal({ supplierOrderId, invoiceId, transportId, receiptOnly, transportLabel, truckOpenQuantities, onClose, onPersisted }: Props) {
  const { t } = useTranslation(['invoices']);
  return (
    <Modal
      open={invoiceId !== null}
      title={[receiptOnly ? t('invoices:workflow.physicalReceipt.title') : t('invoices:workflow.financialApproval.title'), transportLabel].filter(Boolean).join(' · ')}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={1100}
      className="invoice-editor-modal"
      wrapClassName="invoice-editor-modal-wrap"
      destroyOnClose
    >
      {invoiceId && (
        <InvoiceDraftDetail
          key={`${supplierOrderId}:${invoiceId}`}
          direction="PURCHASE"
          embedded={{ invoiceId, supplierOrderId, transportId, receiptOnly, truckOpenQuantities, onClose, onPersisted }}
        />
      )}
    </Modal>
  );
}
